import Markdown from '../../common/Markdown/Markdown';
import './RTE.css';

interface IRTE {
  body: string;
}

function RTE({ body }: IRTE) {
  return (
    <section className="rte section">
      <div className="wrap wrap--sm">
        <Markdown className="rte__body markdown">{body}</Markdown>
      </div>
    </section>
  );
}

export default RTE;
